import React from 'react';
import Login from '../components/Authentication/Login';

const LoginPage = () => {
	return <Login />;
};

export default LoginPage;
